import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MyaccountService } from '../../myalcon-account/services/myaccount.service';
import { ProfileService } from 'src/app/core/services/common/profile.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommunicationService } from 'src/app/core/services/common/communication-service.service';
import { ConfrimModalComponent } from '../../myalcon-account/confirmation.popup-modal.component';
import { Observable, Subscribable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StepupService } from 'src/app/core/stepup/stepup.service';
import { FactorsService } from '../services/factotoenroll.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-privacyandsecurity-settings',
  templateUrl: './privacyandsecurity-settings.component.html',
  styleUrls: ['./privacyandsecurity-settings.component.scss']
})
export class PrivacyandsecuritySettingsComponent implements OnInit {

  invalidData: any;
  public isPhoneFactorEditMode: boolean = false;
  public isSecretQuestionFactorEditMode: boolean = false;
  IsEditProfileEnabled: any;
  factorstoenroll: any[] = [];
  enrolledfactors: any[] = [];
  myfactors: any[] = [];
  smsFactors: any[] = [];
  webauthnFactors:any[] = [];
  qsnFactors: any[] = [];
  webauthnenrolledFactors:any[] = [];
  qsnenrolledFactors: any[] = [];
  smsenrolledFactors: any[] = [];
  factorData: any;
  //isFactorsEnabled = true;
  profile: Observable<unknown> | Subscribable<unknown> | Promise<unknown>;
  userData: any;
  userid: any;
  enablePhoneFactorDisableButton = false;
  enableWebauthnFactorDisableButton = false;
  enableSecretQuestionDisablesButton = false;
  isPhoneFactorErrorMsg = '';
  isSecretQuestionFactorErrorMsg = '';
  defaultPhoneNumber: string = '+0X1 2234 XXX1';
  phoneNumberInput: string = '';
  securityQuestions: { question: string, questionText: string }[] = [];  
  selectedSecurityQuestion: string = '';
  isPhoneFactorSuccessMsg = '';
  isSecretQusFactorSuccessMsg = '';
  isPhoneFactorRemoveMsg:string | null = null ;
  isSecretQusFactorRemoveMsg:string | null = null;
  factor: any;
  public enrollmentStatus: string = 'Checking...';
  authenticatorId: any;
  isModalOpen = false;
  http: any;
  isWebAuthnFactorRemoveMsg: string;
  WebAuthnverificationStatus: boolean  = false;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private communicationService: CommunicationService,
    private stepupService: StepupService,
    private cdr: ChangeDetectorRef,
    public factorsService: FactorsService,
    private modalService: NgbModal,
    private profileService: ProfileService,
    private cdRef: ChangeDetectorRef,
    private dialog: MatDialog,
    // private  webModalComponent : WebModalComponent
      
    
  ) {
    
    // get all factors applicable for the user fill the behavious subject in service
    this.factorsService.getMyFactors();



    // get the latest values and assign it to local varaibles to handle dispaly in UI
    this.communicationService.isPhoneFactorSourceTrue$.subscribe((value) => {
      this.isPhoneFactorEditMode = value;
    });
    this.communicationService.isSecretQuestionFactorSourceTrue$.subscribe(
      (value) => {
        this.isSecretQuestionFactorEditMode = value;
      }
    );
    this.communicationService.isPhoneFactorErrorSummaryTrue$.subscribe((value) => {
      this.isPhoneFactorErrorMsg = value;
    });
    this.communicationService.isSecurityQuestionErrorSummaryTrue$.subscribe((value) => {
      this.isSecretQuestionFactorErrorMsg = value;
    });

   

    this.communicationService.isPhoneFactorSuccessSummaryTrue$.subscribe((value) => {
      this.isPhoneFactorSuccessMsg = value;
      
    });

    this.communicationService.isSecretQusSuccessSummaryTrue$.subscribe((value) => {
   this.isSecretQusFactorSuccessMsg = value
    });

  //   this.communicationService.isPhoneFactorRemoveSummaryTrue$.subscribe((value) => {
  //     this.isPhoneFactorRemoveMsg = value;
      
  //   });

  //   this.communicationService.isSecretQusSuccessSummaryTrue$.subscribe((value) => {
  //  this.isSecretQusFactorRemoveMsg = value
  //   });
    // to set and display UI element using local varibale value setting
    this.factorsService.getFactorsCatlog();
    this.factorsService.getfactorsToEnrolled().subscribe((factorstoenroll) => {
      this.factorstoenroll = factorstoenroll;
      if (this.factorstoenroll) {        
        this.smsFactors = this.factorstoenroll!.filter(
          (factor) => factor.factorType === 'sms' && factor.status == "ACTIVE"
        );
        this.qsnFactors = this.factorstoenroll!.filter(
          (factor) => factor.factorType === 'question' && factor.status == "ACTIVE"
        );
        this.webauthnFactors = this.factorstoenroll!.filter(
          (factor) => factor.factorType === 'webauthn' && factor.status == "ACTIVE"
        )
        if (this.smsFactors.length > 0) {
          this.enablePhoneFactorDisableButton = true; 
          // this.factorData = this.smsFactors[0].profile.phoneNumber;          
        }
        else {
          this.enablePhoneFactorDisableButton = false;          
        }
        if (this.qsnFactors.length > 0) {
          this.enableSecretQuestionDisablesButton = true;
         
        }
        else {
          this.enableSecretQuestionDisablesButton = false;         
        }
        if(this.webauthnFactors.length>0){   

          this.enableWebauthnFactorDisableButton = true;
        }
        else {
          this.enableWebauthnFactorDisableButton = false;         
        }

        

      }

    });
    this.getMyFactors();

  }
  ngOnInit(): void {  
  this.getEnrolledFactors();
   this.factorsService.getFeatureFlags().subscribe((features)  => {
    if  (features  && features['web-authn'])  {
       this.WebAuthnverificationStatus  =  features['web-authn'];
    }
});

    
  }

  /**
   * Loads the Phone Factor component.
   */
  loadPhoneFactorComponent() {
    this.isSecretQuestionFactorErrorMsg = '';
    this.isPhoneFactorErrorMsg = '';   
    this.communicationService.updatePhoneFactoreVariable(true);
    this.communicationService.updateResetSecretQuestionFactorVariable(false);

    //this.openPopup();
    const modalRef = this.modalService.open(ConfrimModalComponent);
    modalRef.componentInstance.conformed.subscribe((receivedEntry: any) => {     

      this.communicationService.isPhoneFactorSourceTrue$.subscribe((value) => {
        this.isPhoneFactorEditMode = value;
      });

      this.communicationService.isSecretQuestionFactorSourceTrue$.subscribe((value) => {
        this.isSecretQuestionFactorEditMode = value;
      });

      //modalRef.close();
      this.getMyFactors();
      this.router.navigate([
        'privacyandsecuritysettings',
        {
          outlets: {
            phonefactor: ['phonefactor'],
            seceretfactors: null,
          },
        },
      ]);
      modalRef.close();      
    });
    modalRef.componentInstance.close.subscribe((receivedEntry: any) => {    
      this.communicationService.updatePhoneFactoreVariable(false);      
      this.communicationService.updateResetSecretQuestionFactorVariable(false);
      this.communicationService.isPhoneFactorSourceTrue$.subscribe((value) => {
        this.isPhoneFactorEditMode = value;
       
      });
      
      this.communicationService.isSecretQuestionFactorSourceTrue$.subscribe((value) => {
        this.isSecretQuestionFactorEditMode = value;
      });

      this.getMyFactors();      
      modalRef.close();
     
    });
    // Navigate to the reset password component in the myaccount outlet
  }

  /**
   * Loads the Secret Qsn component.
   */
  loadSecretFactorComponent() {
    this.isSecretQuestionFactorErrorMsg = '';
    this.isPhoneFactorErrorMsg = '';    
    // Update the reset password source variable in the communication service
    this.communicationService.updateResetSecretQuestionFactorVariable(true);
    this.communicationService.updatePhoneFactoreVariable(false);
    const modalRef = this.modalService.open(ConfrimModalComponent);
    modalRef.componentInstance.conformed.subscribe((receivedEntry: any) => {
      this.communicationService.isSecretQuestionFactorSourceTrue$.subscribe(
        (value) => {
          this.isSecretQuestionFactorEditMode = value;
        }
      );
      this.communicationService.isPhoneFactorSourceTrue$.subscribe(
        (value) => {
          this.isPhoneFactorEditMode = value;
        }
      );
      //modalRef.close();
      this.getMyFactors();
      this.router.navigate([
        'privacyandsecuritysettings',
        {
          outlets: {
            phonefactor: null,
            seceretfactors: ['seceretfactors'],
          },
        },
      ]);
      modalRef.close();
    });
    modalRef.componentInstance.close.subscribe((receivedEntry: any) => {
      this.communicationService.updateResetSecretQuestionFactorVariable(false,'',this.translate.instant('successsecurityfactormsg') );
      // this.communicationService.updateResetSecretQuestionFactorVariable(false);
      this.communicationService.updatePhoneFactoreVariable(false);
      this.communicationService.isSecretQuestionFactorSourceTrue$.subscribe(
        (value) => {
          this.isSecretQuestionFactorEditMode = value;
        }
      );
      this.communicationService.isPhoneFactorSourceTrue$.subscribe(
        (value) => {
          this.isPhoneFactorEditMode = value;
        }
      );
      this.getMyFactors();      
      modalRef.close();
    });
    // Navigate to the reset password component in the myaccount outlet
  }

  // service call to remove / disable already enabled phone factor
  disablePhoneFactorComponent() {
    //this.openPopup();
    const modalRef = this.modalService.open(ConfrimModalComponent);
    modalRef.componentInstance.conformed.subscribe((receivedEntry: any) => {
      this.getMyFactors();
      modalRef.close();
      this.userData = this.profileService.UserProfile.subscribe((data: any) => {
        this.userData = data;
        this.userid = data.sub;
        this.qsnFactors = this.enrolledfactors.filter(
          (factor) => factor.factorType === 'sms'
        );
        if (this.qsnFactors.length == 0) {
          alert('There is no phone factor to disable')
        }
        this.factorsService
          .deleteFactor(this.qsnFactors[0].id, data.sub)
          .subscribe((response) => {
            // Process the response here
            this.factorsService.getMyFactors();
         
            this.resetFactorDataToDefault();
            this.isPhoneFactorRemoveMsg = this.translate.instant('removephonefactormsg');
            setTimeout(() => {
              this.isPhoneFactorRemoveMsg = null; // Hide the message after timeout
            }, 5000); // 5000 milliseconds = 5 seconds
          });
      });
    });
    modalRef.componentInstance.close.subscribe((receivedEntry: any) => {
      this.getMyFactors();
      modalRef.close();
    //   this.resetFactorDataToDefault();
    });

  }

  // service call to remove / disable already Secret QSN factor
  disableSecretFactorComponent() {
    const modalRef = this.modalService.open(ConfrimModalComponent);
    modalRef.componentInstance.conformed.subscribe((receivedEntry: any) => {
      this.getMyFactors();
      modalRef.close();
      this.userData = this.profileService.UserProfile.subscribe((data: any) => {
        this.userData = data;
        this.userid = data.sub;
        this.qsnFactors = this.enrolledfactors.filter(
          (factor) => factor.factorType === 'question'
        );
        this.factorsService
          .deleteFactor(this.qsnFactors[0].id, data.sub)
          .subscribe((response) => {
            // Process the response here
            this.factorsService.getMyFactors();
            this.resetSecurityQuestions();
            this.isSecretQusFactorRemoveMsg =this.translate.instant('removesecurityfactormsg');
          
            setTimeout(() => {
              this.isSecretQusFactorRemoveMsg = null; // Hide the message after timeout
            }, 3000); // 5000 milliseconds = 5 seconds
          
          });
      });
    });
    modalRef.componentInstance.close.subscribe((receivedEntry: any) => {
      this.getMyFactors();
      modalRef.close();
    });
    // this.openPopup();

  }

 loadPassKeyComponent() {
    let authenticatorId = '';

    this.profileService.UserProfile.subscribe({
        next: (data: any) => {
            if (data?.sub) {
                this.factorsService.enrollWebAuthnFactor(data.sub).subscribe({
                    next: (response: any) => {
                        authenticatorId = response?.id || 'defaultAuthenticatorId';

                        if (response?._embedded?.activation) {
                            const activation = response._embedded.activation;

                            try {
                                if (!activation.challenge || !activation.user.id) {
                                    return;
                                }

                                activation.challenge = strToBin(activation.challenge);
                                activation.user.id = strToBin(activation.user.id);
                                activation.timeout = 120000;

                                const pubKeyCredParams: PublicKeyCredentialParameters[] = [
                                    { alg: -7, type: "public-key" },
                                    { alg: -257, type: "public-key" }
                                ];

                                const publicKeyCredentialCreationOptions = {
                                    rp: {
                                        name:environment.myalconaccOktaProfileUS.host,
                                         id:window.location.hostname                                        
                                    },
                                    challenge: activation.challenge,
                                    user: {
                                        id: stringToBufferSource(activation.user.id),
                                        name: activation.user.name,
                                        displayName: activation.user.displayName,
                                    },
                                    pubKeyCredParams,
                                    timeout: activation.timeout,
                                    authenticatorSelection: { requireResidentKey: false },
                                };                               

                                navigator.credentials.create({ publicKey: publicKeyCredentialCreationOptions })
                                    .then((credential) => {
                                        if (credential instanceof PublicKeyCredential) {
                                            const responseData = credential.response as AuthenticatorAttestationResponse;

                                            const clientDataJSON = binToStr(responseData.clientDataJSON);
                                            const attestationObject = binToStr(responseData.attestationObject);

                                            const requestBody = {
                                                attestation: attestationObject,
                                                clientData: clientDataJSON
                                            };

                                            this.factorsService.activateWebAuthnFactor(
                                                data.sub,
                                                response.id,
                                                requestBody
                                            ).subscribe((res) => {
                                               
                                                this.getMyFactors();
                                                 this.enableWebauthnFactorDisableButton= true;
                                               });
                                        }
                                    });                                   
                                   
                            } catch {}
                        }
                    }
                });
            }
        }
    });
}

disablePassKeyComponent() {
    this.profileService.UserProfile.subscribe((data: any) => {
        if (data?.sub) {
            this.userid = data.sub;

            this.factorsService.getenrolledFactors().subscribe((enrolledFactors: any) => {
                const webAuthnFactor = enrolledFactors.find(
                    (factor: any) => factor.factorType === "webauthn"
                );

                if (webAuthnFactor && webAuthnFactor.id) {
                    this.factorsService.deleteFactor(webAuthnFactor.id, data.sub).subscribe(() => {
                        this.factorsService.getMyFactors();
                        this.isWebAuthnFactorRemoveMsg = "Your WebAuthn factor has been removed successfully";

                        setTimeout(() => {
                            this.isWebAuthnFactorRemoveMsg = "";
                            
                        }, 3000);
                      
                        this.getMyFactors();
                         this.enableWebauthnFactorDisableButton= false;
                        
                    });
                }
            });
        }
    });   
}
getEnrolledFactors(): void {
  this.factorsService.getenrolledFactors().subscribe(
    (enrolledFactors: any) => {
      

      // Defensive check for array
      if (!Array.isArray(enrolledFactors)) {       
        this.enrolledfactors = [];
        this.enrollmentStatus = "No enrolled factors";
        this.cdRef.detectChanges();
        return;
      }

      this.enrolledfactors = enrolledFactors;

      const webAuthnFactor = this.enrolledfactors.find(
        (factor: any) => factor?.factorType === 'webauthn'
      );
      this.enrollmentStatus = webAuthnFactor?.status ?? "Not Enrolled";
      this.cdRef.detectChanges();
    },    
  );
}



  //local mehtod to get the factors and display the factor based on the values
  getMyFactors(): void {
      //  this.factorsService.getMyFactors();
        this.factorsService.getenrolledFactors().subscribe((enrolledfactors) => {
      this.enrolledfactors = enrolledfactors;   
      if (enrolledfactors) {   

        this.smsenrolledFactors = this.enrolledfactors!.filter(
          (factor) => factor.factorType === 'sms' && factor.status == "ACTIVE"
        );
        this.qsnenrolledFactors = this.enrolledfactors!.filter(
          (factor) => factor.factorType === 'question' && factor.status == "ACTIVE"
        );
        this.webauthnenrolledFactors = this.enrolledfactors!.filter(
          (factor) => factor.factorType === 'webauthn' && factor.status == "ACTIVE"
        )
      }
        if (this.smsenrolledFactors.length > 0) {
          this.enablePhoneFactorDisableButton = true; 
          // this.factorData = this.smsFactors[0].profile.phoneNumber;          
        }
        else {
          this.enablePhoneFactorDisableButton = false;          
        }
        if (this.qsnenrolledFactors.length > 0) {
          this.enableSecretQuestionDisablesButton = true;
         
        }
        else {
          this.enableSecretQuestionDisablesButton = false;         
        }
        if(this.webauthnenrolledFactors.length>0){   

          this.enableWebauthnFactorDisableButton = true;
        }
        else {
          this.enableWebauthnFactorDisableButton = false;         
        }

      
      if( this.smsenrolledFactors.length >0)
      this.factorData = this.smsenrolledFactors[0].profile.phoneNumber; 
      if( this.qsnenrolledFactors.length >0)    
      this.extractSecurityQuestions(this.qsnenrolledFactors);     
          
    });
   
  } 

  resetSecurityQuestions(): void {
    this.securityQuestions = [];
  }

  maskQuestion(question: string): string {
    const visibleLength = 23; // Show the first 23 characters
    const maskedPart = question.slice(0, visibleLength); // Get the first 23 characters
    return maskedPart + '***'; // Add three asterisks at the end
  }
  
  extractSecurityQuestions(qsnFactors :any ): void {
    this.securityQuestions = qsnFactors.map((factor :any) => {
    
      return {
        question: factor.profile.question,
        questionText: this.maskQuestion(factor.profile.questionText),
      };
    });
  }
  

 

 

  // pop up modal helper method
  openPopup(): void {
    const modalRef = this.modalService.open(ConfrimModalComponent);
    modalRef.componentInstance.conformed.subscribe((receivedEntry: any) => {
      this.getMyFactors();
      modalRef.close();

    });
    modalRef.componentInstance.close.subscribe((receivedEntry: any) => {
      this.getMyFactors();
      modalRef.close();
    });
  }
  clearPhoneNumber(): void {
    this.phoneNumberInput = '';
  }

  validateAndSubmitPhoneNumber(): void {
    const phoneNumberPattern = /^\+?\d{1,4}\s?\d{4}\s?\d{4}$/; // Adjust pattern as needed
    if (phoneNumberPattern.test(this.phoneNumberInput)) {
      this.defaultPhoneNumber = this.phoneNumberInput;
      this.loadPhoneFactorComponent();
    } else {
      alert('Invalid phone number. Please enter a valid phone number.');
    }
  }
  getMaskedPhoneNumber(): string {
    const phoneNumber = this.factorData || this.defaultPhoneNumber;
    if (!phoneNumber) {
      return '****';;
    }
    // Mask half of the phone number
    const visibleDigits = 4; // Number of digits to keep visible from the end
  return '*'.repeat(phoneNumber.length - visibleDigits) + phoneNumber.slice(-visibleDigits);
  }

  resetFactorDataToDefault(): void {
    this.factorData = this.defaultPhoneNumber;
  }
}
function binToStr(buffer: ArrayBuffer): string {
    return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

function stringToBufferSource(input: string): ArrayBuffer {
    const encoder = new TextEncoder();
    return encoder.encode(input).buffer;
}

function fixBase64Encoding(base64: string): string {
    if (typeof base64 !== "string") {
        console.error("Expected a string, received:", base64);
        return "";
    }
    return base64.replace(/-/g, '+').replace(/_/g, '/');
}

function strToBin(str: string): ArrayBuffer {
    try {
        const fixedStr = addBase64Padding(fixBase64Encoding(str));
        return new Uint8Array(atob(fixedStr).split("").map(c => c.charCodeAt(0))).buffer;
    } catch (error) {
        console.error("Base64 Decoding Error:", error, "String:", str);
        return new ArrayBuffer(0);
    }
}
function addBase64Padding(base64: string): string {
    const padLength = base64.length % 4;
    return padLength === 0 ? base64 : base64 + '='.repeat(4 - padLength);
}


